export default __webpack_public_path__ + "static/media/road-map-bg.c5483a00.png";